<div class="d-flex justify-content-start mt-4">
    <app-button
      id="back-desktop" [onlyIcon]="true"
      [isIcon]="true"
      [left]="true"
      [iconName]="'bi bi-arrow-left'"
      [buttonOptions]="buttonOptions"
      (buttonClick)="back()"
    >
    </app-button>
  </div>

<div class="container mt-4 p-4 border rounded shadow-sm bg-light">
  <h2 class="text-success mb-3">✅ Check-in realizado com sucesso!</h2>

  <p class="mb-3">
    Olá <strong>{{ getName() | replaceText }}</strong>, seu check-in para o ingresso
    <strong>{{ checkinData.ticketName }}</strong> foi <strong>{{ checkinData.checkinStatus }}</strong>.
  </p>

  <div class="alert alert-warning" role="alert">
    No dia do jogo, você deverá apresentar sua <strong>identificação facial</strong> para acessar o estádio.
  </div>

  <div class="card my-3">
    <div class="card-body">
      <h5 class="card-title">🎟️ Código de Acesso</h5>
      <div class="d-flex align-items-center">
        <p class="card-text display-6 me-3 mb-0"><strong>{{ checkinData.ticketCode }}</strong></p>
        <i class="bi bi-files" id="btn-copy" (click)="copiarCodigo()"></i>
      </div>
      @if (copiado) {
        <p class="text-success mt-2" >Código copiado com sucesso!</p>
      }
    </div>
  </div>

</div>



